import React, { useState, useEffect } from "react";
import defaultImg from "src/assets/images/defaultImg.png";
import { ImageViewModal } from "src/components/Modals";

const ImageComponent = ({ imagePath }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loader, setLoader] = useState(true);
  const [imageModalIsOpen, setImgModalIsOpen] = useState(false);

  useEffect(() => {
    const getImgLink = () => {
      if (imagePath) {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", imagePath, true);
        xhr.responseType = "blob";
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              const blob = xhr.response;
              const imageUrl = URL.createObjectURL(blob);
              setImageUrl(imageUrl);
            } else {
              setImageUrl(defaultImg);
            }
            setLoader(false);
          }
        };
        xhr.send();
      } else {
        setLoader(false);
      }
    };

    getImgLink();
    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [imagePath]);

  if (loader) {
    return <div>Loading...</div>;
  }

  const handleOpen = () => {
    // getImgLink(rowData);
    setImgModalIsOpen(true);
    // SetModalloader(true);
  };

  return (
    <div>    
      <img
        onClick={()=>handleOpen()}
        loading="lazy"
        src={imageUrl || defaultImg}
        alt="images"
        className="visualReferencesImg"
      />
      {imageModalIsOpen && (
        <ImageViewModal
          src={imageUrl || defaultImg}
          open={imageModalIsOpen}
          handleClose={() => setImgModalIsOpen(false)}
        />
      )}
    </div>
  );
};

export default ImageComponent;